(function () {
  function makeAutoScroller(root, track, options) {
    options = options || {};
    var intervalSeconds = parseFloat(root.dataset.autoScrollInterval) || 4;
    var mql = window.matchMedia('(min-width: 750px)');
    var timer = null;
    var resumeTimeout = null;

    function isCarouselActive() {
      var layout = mql.matches ? root.dataset.desktopLayout : root.dataset.mobileLayout;
      return layout === 'carousel';
    }

    function hasOverflow() {
      return track.scrollWidth > track.clientWidth + 1;
    }

    function stepAmount() {
      if (options.stepAmount) return options.stepAmount();
      return track.clientWidth;
    }

    function tick() {
      if (!isCarouselActive() || !hasOverflow()) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      if (track.scrollLeft >= maxScroll) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: stepAmount(), behavior: 'smooth' });
      }
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!isCarouselActive() || !hasOverflow()) return;
      timer = window.setInterval(tick, intervalSeconds * 1000);
    }

    function pauseThenResume() {
      stop();
      if (resumeTimeout) window.clearTimeout(resumeTimeout);
      resumeTimeout = window.setTimeout(start, intervalSeconds * 1000);
    }

    track.addEventListener('pointerenter', stop);
    track.addEventListener('pointerleave', start);
    track.addEventListener('touchstart', pauseThenResume, { passive: true });
    mql.addEventListener('change', start);

    return { start: start, pauseThenResume: pauseThenResume };
  }

  function initReelShowcase(root) {
    var track = root.querySelector('[data-reel-track]');
    var prev = root.querySelector('[data-reel-prev]');
    var next = root.querySelector('[data-reel-next]');
    var infoTrack = root.querySelector('[data-reel-info-track]');

    if (track && prev && next) {
      var tileScrollAmount = function () {
        var tile = track.querySelector('.reel-showcase__tile');
        if (!tile) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || 0);
        return tile.getBoundingClientRect().width + gap;
      };

      var updateArrowState = function () {
        var maxScroll = track.scrollWidth - track.clientWidth - 1;
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= maxScroll;
      };

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -tileScrollAmount(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: tileScrollAmount(), behavior: 'smooth' });
      });

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          updateArrowState();
          ticking = false;
        });
      });

      window.addEventListener('resize', updateArrowState);
      updateArrowState();

      if (root.dataset.autoScroll === 'true') {
        var tileScroller = makeAutoScroller(root, track, { stepAmount: tileScrollAmount });
        prev.addEventListener('click', tileScroller.pauseThenResume);
        next.addEventListener('click', tileScroller.pauseThenResume);
        tileScroller.start();
      }
    }

    if (infoTrack && root.dataset.autoScroll === 'true') {
      var infoScroller = makeAutoScroller(root, infoTrack);
      window.addEventListener('resize', infoScroller.start);
      infoScroller.start();
    }
  }

  function initAll(scope) {
    var sections = (scope || document).querySelectorAll('[data-reel-showcase]');
    sections.forEach(initReelShowcase);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();